// src/components/LoadingText.js

import React from "react";
import "./style/LazyLoad.css";

function LazyLoad({
  loading,
  children,
  width = "200px",
  height = "20px",
}) {
  if (loading) {
    return (
      <div
        className="loading-text"
        style={{
          width,
          height,
        }}
      ></div>
    );
  }

  return <>{children}</>;
}

export default LazyLoad;